import { axios } from '../../../../../utils/settings';
import { DownloadNpsTransactionStatementUrl, gapDetailsUrl } from '../urls';
import { toast } from 'react-toastify';
import { downloadFileInAndroid, downloadFileInBrowser } from '../../../../Common/Download Button/downloadButtonUtils';
import { getToken, getTokenHeader } from '../../../../Common/Token';
import { createActionErrorCapture } from '../../../../../utils/sentryUtils';

const captureError = createActionErrorCapture('benefits-gap');

export const getGAPDetails = async () => {
  try {
    const token = await getToken();
    const { data } = await axios.get(`${gapDetailsUrl()}`, getTokenHeader(token));
    return data;
  } catch (err) {
    captureError(err, 'getGAPDetails');
    return { error: true, message: err.response?.data?.message || err.message };
  }
};

export const downloadNpsTransactionStatementAction = async (beneficiary_id, file_name) => {
  try {
    let token = await getToken();

    const queryParams = new URLSearchParams();
    queryParams.append('beneficiary_id', beneficiary_id);

    const url = `${DownloadNpsTransactionStatementUrl()}?${queryParams.toString()}`;

    const response = await fetch(url, {
      method: 'GET',
      ...getTokenHeader(token),
    });

    const blob = await response.blob();

    if (blob.type.includes('application/json')) {
      const displayName = file_name.replace('.pdf', '');
      toast.error(`No ${displayName} Found`);
      return Promise.reject(new Error(`No ${displayName} Found`));
    }
    const isAndroidWebView = /Android/i.test(navigator.userAgent) && window.navigator.userAgent.includes('wv');
    if (isAndroidWebView) {
      await downloadFileInAndroid(blob, file_name);
    } else {
      await downloadFileInBrowser(blob, file_name);
    }
    toast.success('File downloaded successfully');
  } catch (err) {
    captureError(err, 'downloadNpsTransactionStatement');
    toast.error('Download failed. Please try again.');
    return Promise.reject(err);
  }
};